import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import female_profile from "../../Images/female_profile.png";
import male_profile from "../../Images/male_profile.png";
import API from "../Api/API";
import AsyncImage from "../AsyncImage/AsyncImage";
import { enlargeImage } from "../EnlargeImage/EnlargeImage";
import { handleErrorMessage } from "../ErrorMessages/ErrorMessages";

const CoachSelectForm = ({
  primaryColor,
  currentCoach,
  pendingCoach,
  onPendingSelect,
}) => {
  const [coaches, setCoaches] = useState([]);

  const primaryColorText = { color: primaryColor };
  const primaryColorBg = {
    backgroundColor: primaryColor,
    borderColor: primaryColor,
  };
  const tableStyle = { borderColor: "lightgray", verticalAlign: "middle" };

  const { t } = useTranslation(["coach"]);

  useEffect(() => {
    fetchCoaches().then((list) => {
      list.forEach((manager) => {
        if (manager.photoPath === null) {
          manager.photoSrc =
            manager.sex === "FEMALE" ? female_profile : male_profile;
        }
      });
      setCoaches(list);
    });
  }, []);

  const fetchCoaches = () =>
    axios
      .get(API.url + "api/club/all-coaches", { withCredentials: true })
      .then((res) => res.data)
      .catch((err) => handleErrorMessage(err.response.status));

  return (
    <div>
      {coaches.length > 0 ? (
        <div className="table-container">
          <table className="table table-hover">
            <tbody>
              {coaches.map((manager, index) => (
                <tr key={"manager_" + index}>
                  <td className="manager_table_item" style={tableStyle}>
                    <div className="profile_image_container">
                      {manager.photoPath ? (
                        <AsyncImage
                          src={API.url + "api/user/download/" + manager.id}
                          className="profile_photo m-1"
                          onClick={enlargeImage}
                        />
                      ) : (
                        <img
                          src={manager.photoSrc}
                          className="profile_photo"
                          onClick={enlargeImage}
                          alt=""
                        />
                      )}
                    </div>
                  </td>
                  <td className="club_table_item" style={tableStyle}>
                    <h6
                      style={primaryColorText}
                      className="club_member_name mb-0"
                    >
                      {manager.lastName + " " + manager.firstName}
                    </h6>
                  </td>
                  <td className="club_table_item" style={tableStyle}>
                    <h6
                      style={primaryColorText}
                      className="club_member_email mb-0"
                    >
                      {manager.email}
                    </h6>
                  </td>
                  <td className="club_table_item" style={tableStyle}>
                    {currentCoach?.id !== manager.id && (
                      <button
                        className="btn btn-primary m-1"
                        style={
                          pendingCoach?.id !== manager.id
                            ? {
                                backgroundColor: "white",
                                borderColor: primaryColor,
                                color: primaryColor,
                              }
                            : primaryColorBg
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          onPendingSelect(
                            pendingCoach?.id === manager.id ? null : manager,
                          );
                        }}
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <h4 style={primaryColorText} className="empty_list_text">
          {t("no_coaches")}
        </h4>
      )}
    </div>
  );
};

export default CoachSelectForm;
